import { BigTitle } from 'shared/components/BigTitle';
import { Block } from 'shared/components/Block';
import { TextInfoWithImage } from 'shared/components/TextInfoWithImage';
import { Wrapper } from 'shared/components/Wrapper';
import * as styles from './styles.css';
import { DESCRIPTION, LIST } from './constants';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const OtaModel: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <Element name={ENavigation.OtaModel}>
          <Block>
            <BigTitle text="OTA-модель: новая экономика краткосрочной аренды" />
            <TextInfoWithImage
              listTitle="Формат обеспечивает:"
              list={LIST}
              description={DESCRIPTION}
              image="calendar"
            />
          </Block>
        </Element>
      </Wrapper>
    </div>
  );
};
